import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const TrackSteps = ({track, color, patternNumber}) => { 
    let pattern = track.patterns[patternNumber];
    if (!pattern) {
        return [];
    }
    let steps = new Array(Math.min(16, (pattern.size / 2))).fill(0)
    return (
        <div className="track-steps">
          {steps.map(
              (x,i) =>
                  <div style={pattern[i*2] ? {backgroundColor: color} : {}}
                       className="track-step"/>
          )}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackSteps);
